var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaredArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15728",
    "data-name": "Group 15728",
    transform: "translate(-102 -112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4564",
    "data-name": "Rectangle 4564",
    width: 10,
    height: 10,
    rx: 2,
    transform: "translate(102 112)",
    fill: "rgba(0,0,0,0.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M2.486.857a.6.6,0,0,1,1.029,0l1.94,3.234A.6.6,0,0,1,4.94,5H1.06a.6.6,0,0,1-.514-.909Z",
    transform: "translate(110 114) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaredArrow);
export default __webpack_public_path__ + "static/media/stared-arrow.a7c9c297.svg";
export { ForwardRef as ReactComponent };